import { ConfiguratorStructureStep } from './configurator-structure-step';

export class ConfiguratorStructure {
  steps: ConfiguratorStructureStep[];

  constructor(steps: ConfiguratorStructureStep[]) {
    this.steps = steps;
  }
}
